import { Routes } from '@angular/router';
import { accessGuard } from '@guards/access.guard';
import { authGuard } from '@guards/auth.guard';

const MainLayoutRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/layout-main/layout-main.component').then((m) => m.LayoutMainComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: '',
        loadChildren: () => import('./pages/statics/statics.routes').then((m) => m.staticRoutes),
      },
      {
        path: 'p/:programUId',
        loadComponent: () =>
          import('./pages/program/program.component').then((m) => m.ProgramComponent),
      },
      {
        path: 'e/:episodeUId',
        loadComponent: () =>
          import('./pages/episode/episode.component').then((m) => m.EpisodeComponent),
      },
      {
        path: 't/:descriptor',
        loadComponent: () => import('./pages/tag/tag.component').then((m) => m.TagComponent),
      },
      {
        path: 'g',
        loadChildren: () => import('./pages/genres/genres.routes').then((m) => m.genreRoutes),
      },
      {
        path: 'c',
        loadChildren: () =>
          import('./pages/categories/categories.routes').then((m) => m.categoryRoutes),
      },
      {
        path: 'a/:descriptor',
        loadComponent: () =>
          import('./pages/artist/artist.component').then((m) => m.ArtistComponent),
      },
      {
        path: 'search',
        loadChildren: () => import('./pages/search/search.routes').then((m) => m.searchRoutes),
      },
      {
        path: 'devices',
        loadComponent: () =>
          import('./pages/devices-limit/devices-limit.component').then(
            (m) => m.DevicesLimitComponent,
          ),
      },
      {
        path: 'watch-list',
        canActivate: [accessGuard],
        loadComponent: () =>
          import('./pages/watch-list/watch-list.component').then((m) => m.WatchListComponent),
      },
      {
        path: 'bt/:programUid',
        canActivate: [accessGuard],
        loadComponent: () =>
          import('./pages/buy-online-screen-ticket/buy-online-screen-ticket.component').then(
            (m) => m.BuyOnlineScreenTicketComponent,
          ),
      },
    ],
  },
];

const PlayerLayoutRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/layout-player/layout-player.component').then((m) => m.LayoutPlayerComponent),
    children: [
      {
        path: 'w/:episodeUId',
        canActivate: [accessGuard],
        loadComponent: () => import('./pages/watch/watch.component').then((m) => m.WatchComponent),
      },
      {
        path: 'pr/:trailerId',
        loadComponent: () =>
          import('./pages/preview/preview.component').then((m) => m.PreviewComponent),
      },
    ],
  },
];

const AuthLayoutRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/layout-auth/layout-auth.component').then((m) => m.LayoutAuthComponent),
    children: [
      {
        path: 'auth',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/authentication/authentication.component').then(
            (m) => m.AuthenticationComponent,
          ),
      },
    ],
  },
];

const ErrorLayoutRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/layout-error/layout-error.component').then((m) => m.LayoutErrorComponent),
    children: [
      {
        path: 'error',
        loadChildren: () => import('./pages/errors/errors.routes').then((m) => m.errorRoutes),
      },
    ],
  },
];

const AccountLayoutRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/layout-setting/layout-setting.component').then(
        (m) => m.LayoutSettingComponent,
      ),
    children: [
      {
        path: 'account',
        canActivate: [accessGuard],
        loadChildren: () => import('./pages/account/account.routes').then((m) => m.accountRoutes),
      },
    ],
  },
];

const NoLayoutRoutes: Routes = [
  {
    path: 'choose-profile',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./pages/choose-profile/choose-profile.component').then(
        (m) => m.ChooseProfileComponent,
      ),
  },
  {
    path: 'profile',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./components/profile/profile.component').then((m) => m.ProfileComponent),
  },
  {
    path: 'preparation',
    loadComponent: () =>
      import('./pages/preparation/preparation.component').then((m) => m.PreparationComponent),
  },
];

export const routes: Routes = [
  ...MainLayoutRoutes,
  ...PlayerLayoutRoutes,
  ...AuthLayoutRoutes,
  ...AccountLayoutRoutes,
  ...NoLayoutRoutes,
  ...ErrorLayoutRoutes,
  {
    path: '**',
    redirectTo: '/error/404',
    pathMatch: 'full',
  },
];
